import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: var(--background);
`;

export const NotFoundCard = styled.div`
  background: var(--surface);
  padding: 60px 40px;
  border-radius: 25px;
  border: 2px solid var(--accent-light);
  box-shadow: var(--shadow-soft);
  text-align: center;
  max-width: 500px;
  width: 100%;
  animation: ${fadeInUp} 0.8s ease-out;

  @media (max-width: 768px) {
    padding: 40px 30px;
    margin: 20px;
  }
`;

export const ErrorCode = styled.div`
  font-size: 80px;
  font-weight: 700;
  color: var(--accent);
  line-height: 1;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 64px;
  }
`;

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Message = styled.p`
  font-size: 16px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

export const HomeButton = styled.button`
  background: var(--gradient-primary);
  color: var(--surface);
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-soft);
  display: inline-flex;
  align-items: center;
  gap: 10px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-medium);
    background: var(--accent-dark);
  }
`;
